import CompletedWorks from "../views/CompletedWorks/CompletedWorks.vue";
import Vue from 'vue'
import VueRouter from 'vue-router'
import {redirectLegacyAnnulment} from '../utils/reportAnnulmentNavigation';
import Home from '../views/Home.vue'
import Users from '../views/Users/Users.vue'
import UserCard from '../views/Users/UserCard.vue'
import EmployeeWorkforceBoard from '../views/EmployeesWorkforce/EmployeeWorkforceBoard.vue'
import EmployeeWorkforcePlan from '../views/EmployeesWorkforce/EmployeeWorkforcePlan.vue'
import EmployeeWorkforceSettings from '../views/EmployeesWorkforce/EmployeeWorkforceSettings.vue'
import EmployeeRegistry from '../views/EmployeesWorkforce/EmployeeRegistry.vue'
import EmployeeDetails from '../views/EmployeesWorkforce/EmployeeDetails.vue'
import EmployeeOneCImport from '../views/EmployeesWorkforce/EmployeeOneCImport.vue'
import EmployeeMergeReview from '../views/EmployeesWorkforce/EmployeeMergeReview.vue'
import TimesheetWorkspace from '../views/Timesheets/TimesheetWorkspace.vue'
import timesheetReviewGrid from '../utils/timesheetReviewGrid'
import TimesheetSettings from '../views/Timesheets/TimesheetSettings.vue'
import TimesheetHistoryImport from '../views/Timesheets/TimesheetHistoryImport.vue'
import TimesheetHistoryPeople from '../views/Timesheets/TimesheetHistoryPeople.vue'
import PayrollWorkspace from '../views/Payroll/PayrollWorkspace.vue'
import Login from '../views/Login.vue'
import Objects from '../views/Objects/Objects.vue'
import ObjectGroups from '../views/Objects/ObjectGroups.vue'
import ObjectGroupCard from '../views/Objects/ObjectGroupCard.vue'
import ObjectCard from '../views/Objects/ObjectCard.vue'
import ObjectPreparations from '../views/Objects/ObjectPreparations.vue'
import UserChats from '../views/UserChats.vue'
import SecondWorks from "../views/SecondWorks/SecondWorks.vue";
import Targets from "../views/Targets/Targets.vue";
import TypesOfWorks from '../views/TypesWork.vue'
import store from '../store/store';
import WorkTypes from "../views/WorkTypes/WorkTypes.vue";
import FuelLimits from "../views/FuelLimits/FuelLimits.vue";
import FuelCards from "../views/FuelCards/FuelCards.vue";
import MechanicAssets from "../views/MechanicAssets/MechanicAssets.vue";
import MechanicAssetPage from "../views/MechanicAssets/MechanicAssetPage.vue";
import UsedFuels from "../views/UsedFuels/UsedFuels.vue";
import CreateObjectWizard from "../views/CreateObjectWizard/CreateObjectWizard.vue";
import WorkGroups from "../views/WorkGroups/WorkGroups.vue";
import MaterialDirectory from "../views/Materials/Directory/MaterialDirectory.vue";
import MaterialGroups from "../views/Materials/Groups/MaterialGroups.vue";
import MaterialTargets from "../views/Materials/Targets/MaterialTargets.vue";
import MaterialUsing from "../views/Materials/Using/MaterialUsing.vue";
import Charts from "../views/Charts/Charts.vue";
import Gallery from "../views/Gallery/Gallery.vue";
import ReportsManagement from "../views/ReportsManagement/ReportsManagement.vue";
import AlertsManagement from "../views/AlertsManagement/AlertsManagement.vue";
import UserGroups from "@/views/UserGroups/UserGroups";
import Departments from "@/views/Departments/Departments";
import TelegramDatepicker from "@/views/TelegramDatepicker/TelegramDatepicker";
import Tasks from "@/views/Tasks/Tasks";
import TaskCard from "@/views/Tasks/TaskCard/TaskCard";
import Requests from "@/views/Requests/Requests";
import RequestCard from "@/views/Requests/RequestCard/RequestCard";
import Reports from "@/views/Reports/Reports";
import ReportCard from "@/views/Reports/ReportCard";
import CreateRequest from "@/views/Requests/CreateRequest/CreateRequest";
import RequestTypes from "@/views/Requests/RequestTypes/RequestTypes";
import RequestTypeForm from "@/views/Requests/RequestTypes/RequestTypeForm";
import DeleteShiftReport from "@/views/Requests/DeleteReport/DeleteShiftReport";
import RequestCreate from "@/views/Requests/DeleteReport/RequestCreate/RequestCreate";
import RequestDeleteReportCard from "@/views/Requests/DeleteReport/RequestDeleteReportCard/RequestDeleteReportCard";
import AdminPanel from "@/views/AdminPanel/AdminPanel";
import ShiftReport from "@/views/ShiftReport/ShiftReport";
import TestAndroidWebView from "@/views/TestAndroidWebView.vue";
import PlatformLogin from "@/views/Platform/PlatformLogin.vue";
import PlatformConsole from "@/views/Platform/PlatformConsole.vue";
import InstallApp from "@/views/Install/InstallApp.vue";
import More from "@/views/More/More.vue";
import About from "@/views/About/About.vue";
import WorkspaceShortcut from "@/views/WorkspaceShortcut.vue";
import {
    canRestorePlatformSession,
    isPlatformAccessTokenValid
} from "@/platform/session";

Vue.use(VueRouter);

const getCurrentScrollPosition = () => {
    if (typeof window === 'undefined') {
        return {x: 0, y: 0};
    }
    const doc = document.documentElement;
    const body = document.body;
    return {
        x: window.pageXOffset || (doc && doc.scrollLeft) || (body && body.scrollLeft) || 0,
        y: window.pageYOffset || (doc && doc.scrollTop) || (body && body.scrollTop) || 0
    };
};

const redirectWorkShiftsToReports = to => {
    const query = {...(to.query || {})};
    const shiftId = query.shiftId || query.shift_id;
    const shouldOpenPhotoUpload =
        query.openPhotoUpload === 'true'
        || query.openPhotosModal === 'true';

    delete query.shiftId;
    delete query.shift_id;
    delete query.openPhotoUpload;
    delete query.openPhotosModal;

    if (shiftId) {
        const target = {
            path: `/reports/${shiftId}`,
            query
        };
        if (shouldOpenPhotoUpload) {
            target.query = {
                ...target.query,
                openPhotoUpload: 'true'
            };
        }
        return target;
    }

    return {
        path: '/reports',
        query
    };
};

const routes = [
    {
        path: '/install',
        name: 'install-app',
        component: InstallApp,
        meta: {standalone: true}
    },
    {
        path: '/platform/login',
        name: 'platform-login',
        component: PlatformLogin,
        meta: {platform: true, platformGuest: true, standalone: true}
    },
    {
        path: '/platform',
        name: 'platform-console',
        component: PlatformConsole,
        meta: {platform: true, requiresPlatformAuth: true, standalone: true}
    },
    {
        path: '*',
        component: Home,
        meta: {requiresAuth: true}
    },
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: {requiresAuth: true, title: 'Главная'}
    },
    {
        path: '/workspace',
        name: 'workspace-shortcut',
        component: WorkspaceShortcut,
        meta: {requiresAuth: true, title: 'Моя вкладка'}
    },
    {
        path: '/more',
        name: 'more',
        component: More,
        meta: {requiresAuth: true, title: 'Ещё'}
    },
    {
        path: '/about',
        name: 'about',
        component: About,
        meta: {requiresAuth: true, title: 'О приложении'}
    },
    {
        path: '/completed-works',
        name: 'CompletedWorks',
        component: CompletedWorks,
        meta: {requiresAuth: true}
    },
    {
        path: '/create-object-wizard',
        name: 'CreateObjectWizard',
        component: CreateObjectWizard,
        meta: {requiresAuth: true, immersive: true, title: 'Создание объекта'}
    },
    {
        path: '/fuel-limits',
        name: 'FuelLimits',
        component: FuelLimits,
        meta: {requiresAuth: true}
    },
    {
        path: '/fuel-cards',
        name: 'FuelCards',
        component: FuelCards,
        meta: {requiresAuth: true}
    },
    {
        path: '/mechanic-assets',
        name: 'MechanicAssets',
        component: MechanicAssets,
        meta: {requiresAuth: true}
    },
    {
        path: '/mechanic-assets/:id',
        name: 'MechanicAssetCard',
        component: MechanicAssetPage,
        meta: {requiresAuth: true}
    },
    {
        path: `/systemUsers`,
        name: `SystemUsers`,
        redirect: '/users',
        meta: {requiresAuth: true}
    },
    {
        path: `/systemUserForm`,
        name: `SystemUserForm`,
        redirect: '/users',
        meta: {requiresAuth: true}
    },
    {
        path: `/targets`,
        name: `Targets`,
        component: Targets,
        meta: {requiresAuth: true}
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {standalone: true}
    },
    {
        path: '/users',
        name: 'users',
        component: Users,
        meta: {requiresAuth: true, title: 'Учётные записи'}
    },
    {
        path: '/employees',
        name: 'employees',
        component: EmployeeRegistry,
        meta: {requiresAuth: true, title: 'Сотрудники'}
    },
    {
        path: '/timesheets',
        name: 'timesheets',
        component: TimesheetWorkspace,
        meta: {
            requiresAuth: true,
            title: 'Табели',
            collapseDesktopSidebarTemporarily: true,
            hideMobileBottomNavigation: true
        }
    },
    {
        path: '/timesheets/settings',
        name: 'timesheet-settings',
        component: TimesheetSettings,
        meta: {requiresAuth: true, title: 'Настройки табелей'}
    },
    {
        path: '/timesheets/import',
        name: 'timesheet-history-import',
        component: TimesheetHistoryImport,
        meta: {requiresAuth: true, title: 'Перенос истории табелей'}
    },
    {
        path: '/timesheets/history-people',
        name: 'timesheet-history-people',
        component: TimesheetHistoryPeople,
        meta: {requiresAuth: true, title: 'Сотрудники архива'}
    },
    {
        path: '/timesheets/:timesheetId(\\d+)',
        name: 'timesheet',
        component: TimesheetWorkspace,
        meta: {
            requiresAuth: true,
            title: 'Табель',
            collapseDesktopSidebarTemporarily: true,
            hideMobileBottomNavigation: true
        }
    },
    {
        path: '/payroll',
        name: 'payroll',
        component: PayrollWorkspace,
        meta: {requiresAuth: true, title: 'Начисление зарплаты'}
    },
    {
        path: '/employees/workforce',
        name: 'employees-workforce',
        component: EmployeeWorkforceBoard,
        meta: {
            requiresAuth: true,
            title: 'Распределение сотрудников',
            collapseDesktopSidebarTemporarily: true
        }
    },
    {
        path: '/employees/workforce/plan',
        name: 'employees-workforce-plan',
        component: EmployeeWorkforcePlan,
        meta: {
            requiresAuth: true,
            title: 'План сотрудников',
            collapseDesktopSidebarTemporarily: true,
            hideMobileBottomNavigation: true
        }
    },
    {
        path: '/employees/workforce/settings',
        name: 'employees-workforce-settings',
        component: EmployeeWorkforceSettings,
        meta: {requiresAuth: true, title: 'Настройки модуля «Сотрудники»'}
    },
    {
        path: '/employees/import/1c-zup',
        name: 'employee-one-c-import',
        component: EmployeeOneCImport,
        meta: {requiresAuth: true, title: 'Импорт сотрудников из 1С'}
    },
    {
        path: '/employees/merge-review',
        name: 'employee-merge-review',
        component: EmployeeMergeReview,
        meta: {requiresAuth: true, title: 'Требует сверки: дубли сотрудников'}
    },
    {
        path: '/employees/:id',
        name: 'employee-details',
        component: EmployeeDetails,
        meta: {requiresAuth: true, title: 'Карточка сотрудника'}
    },
    {
        path: '/profile',
        name: 'profile',
        component: UserCard,
        meta: {requiresAuth: true}
    },
    {
        path: '/users/create',
        name: 'create-user',
        component: UserCard,
        meta: {requiresAuth: true}
    },
    {
        path: '/users/:id',
        name: 'user-card',
        component: UserCard,
        meta: {requiresAuth: true}
    },
    {
        path: '/objects',
        name: 'objects',
        component: Objects,
        meta: {requiresAuth: true}
    },
    {
        path: '/objects/create',
        name: 'object-create',
        redirect: '/create-object-wizard',
        meta: {requiresAuth: true}
    },
    {
        path: '/objects/groups',
        name: 'object-groups',
        component: ObjectGroups,
        meta: {requiresAuth: true, title: 'Группы строительных объектов'}
    },
    {
        path: '/objects/groups/:id',
        name: 'object-group-card',
        component: ObjectGroupCard,
        meta: {requiresAuth: true, title: 'Группа строительных объектов'}
    },
    {
        path: '/objects/preparations/:id?',
        name: 'object-preparations',
        component: ObjectPreparations,
        meta: {requiresAuth: true, title: 'Подготовка объектов'}
    },
    {
        path: '/objects/:id',
        name: 'object-card',
        component: ObjectCard,
        meta: {requiresAuth: true}
    },
    {
        path: '/objects-in-process',
        name: 'objectsInProcess',
        redirect: '/objects',
        meta: {requiresAuth: true}
    },
    {
        path: '/used-fuels',
        name: 'UsedFuels',
        component: UsedFuels,
        meta: {requiresAuth: true}
    },
    {
        path: '/user-chats',
        name: 'user-chats',
        component: UserChats,
        meta: {requiresAuth: true}
    },
    {
        path: '/second-works',
        name: 'second-works',
        component: SecondWorks,
        meta: {requiresAuth: true}
    },
    {
        path: '/types-of-works',
        name: 'types-of-works',
        component: TypesOfWorks,
        meta: {requiresAuth: true}
    },
    {
        path: '/work-types',
        name: 'workTypes',
        component: WorkTypes,
        meta: {requiresAuth: true}
    },
    {
        path: '/work-groups',
        name: 'workGroups',
        component: WorkGroups,
        meta: {requiresAuth: true}
    },
    {
        path: `/work-shifts`,
        name: `workShifts`,
        redirect: redirectWorkShiftsToReports,
        meta: {requiresAuth: true}
    },
    {
        path: `/materials`,
        name: `materials`,
        component: MaterialDirectory,
        meta: {requiresAuth: true}
    },
    {
        path: `/material-groups`,
        name: `materialGroups`,
        component: MaterialGroups,
        meta: {requiresAuth: true}
    },
    {
        path: `/material-targets`,
        name: `materialTargets`,
        component: MaterialTargets,
        meta: {requiresAuth: true}
    },
    {
        path: `/material-using`,
        name: `materialUsing`,
        component: MaterialUsing,
        meta: {requiresAuth: true}
    },
    {
        path: `/charts`,
        name: `charts`,
        component: Charts,
        meta: {requiresAuth: true}
    },
    {
        path: `/gallery`,
        name: `gallery`,
        component: Gallery,
        meta: {requiresAuth: true}
    },
    {
        path: `/reports`,
        name: `reports`,
        component: Reports,
        meta: {requiresAuth: true}
    },
    {
        path: `/reports/:id`,
        name: `report-card`,
        component: ReportCard,
        meta: {requiresAuth: true}
    },
    {
        path: `/reports-management`,
        name: `reports-management`,
        component: ReportsManagement,
        meta: {requiresAuth: true}
    },
    {
        path: `/alerts-management`,
        name: `alerts-management`,
        component: AlertsManagement,
        meta: {requiresAuth: true}
    },
    {
        path: `/user-groups`,
        name: `user-groups`,
        component: UserGroups,
        meta: {requiresAuth: true}
    },
    {
        path: `/departments`,
        name: `departments`,
        component: Departments,
        meta: {requiresAuth: true}
    },
    {
        path: `/telegram-datepicker`,
        name: `telegram-datepicker`,
        component: TelegramDatepicker,
        meta: {requiresAuth: false}
    },
    {
        path: `/tasks`,
        name: `tasks`,
        component: Tasks,
        meta: {requiresAuth: true, title: 'Задачи'}
    },
    {
        path: `/tasks/:id`,
        name: `task-card`,
        component: TaskCard,
        meta: {requiresAuth: true}
    },
    {
        path: `/requests`,
        name: `requests`,
        component: Requests,
        meta: {requiresAuth: true, title: 'Заявки'}
    },
    {
        path: `/requests/create`,
        name: `create-request`,
        component: CreateRequest,
        meta: {requiresAuth: true, immersive: true, title: 'Новая заявка'}
    },
    {
        path: `/requests/types`,
        name: `request-types`,
        component: RequestTypes,
        meta: {requiresAuth: true}
    },
    {
        path: `/requests/types/create`,
        name: `create-request-type`,
        component: RequestTypeForm,
        meta: {requiresAuth: true, immersive: true, title: 'Новый тип заявки'}
    },
    {
        path: `/requests/types/:id/edit`,
        name: `edit-request-type`,
        component: RequestTypeForm,
        meta: {requiresAuth: true, immersive: true, title: 'Настройка типа заявки'}
    },
    {
        path: `/requests/delete-shift-report`,
        name: `requests-delete-shift-report`,
        beforeEnter: redirectLegacyAnnulment,
        component:  DeleteShiftReport,
        meta: {requiresAuth: true}
    },
    {
        path: `/requests/delete-shift-report/create`,
        name: `delete-shift-report-requests-create`,
        beforeEnter: redirectLegacyAnnulment,
        component:  RequestCreate,
        meta: {requiresAuth: true, immersive: true, title: 'Аннулирование отчёта'}
    },
    {
        path: `/requests/delete-shift-report/:id`,
        name: `delete-shift-report-card`,
        beforeEnter: redirectLegacyAnnulment,
        component: RequestDeleteReportCard,
        meta: {requiresAuth: true}
    },
    {
        path: `/requests/:id`,
        name: `request-card`,
        component: RequestCard,
        meta: {requiresAuth: true}
    },
    {
        path: `/admin-panel`,
        name: `admin-panel`,
        component: AdminPanel,
        meta: {requiresAuth: true}
    },
    {
        path: `/shift-report-master`,
        name: `ShiftReport`,
        component: ShiftReport,
        meta: {requiresAuth: true, immersive: true, title: 'Отчёт по смене'}
    },
    {
        path: `/test-android-webview`,
        name: `test-android-webview`,
        component: TestAndroidWebView,
        meta: {requiresAuth: false}
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        // Каталог уже готов при переходе: показываем шапку сразу, без скачка через 1–2 секунды.
        if (to.name === 'more') return savedPosition || {x: 0, y: 0};
        // The task list restores its page, scroll position and highlighted row after loading.
        if (to.name === 'tasks') return getCurrentScrollPosition();
        // The workspace restores review scroll or focuses the source after loading.
        if (timesheetReviewGrid.ownsScroll(to)) return false;
        if (to.name === 'timesheet' && to.query && /^[1-9]\d*$/.test(to.query.focus_employee_id || '')) return false;
        if (['timesheets', 'timesheet'].includes(to.name) && to.query && to.query.attention === 'arrivals') return false;
        return new Promise((resolve) => {
            setTimeout(() => {
                // Таймер предыдущего перехода не должен прокручивать уже открытую другую страницу.
                if (router.currentRoute !== to) {
                    resolve(getCurrentScrollPosition());
                    return;
                }
                if (to.name === `requests`) {
                    // У заявочника свой внутренний скролл; внешний документ держим сверху,
                    // иначе панель списка может уехать под верхнюю шапку сайта.
                    resolve({x: 0, y: 0});
                } else if (
                    to.name === `request-types`
                    && (
                        from.name === `request-types`
                        || from.name === `edit-request-type`
                        || from.name === `create-request-type`
                        || (to.query && to.query.highlight)
                        || (from.query && from.query.highlight)
                    )
                ) {
                    // Таблица типов сама восстанавливает фильтры, страницу и плавно доводит до строки.
                    // Возвращаем текущую позицию: в этой версии vue-router resolve(false)
                    // всё равно может закончиться поздним window.scrollTo({top: 0}).
                    resolve(getCurrentScrollPosition());
                } else if (
                    from.name === `request-types`
                    && (to.name === `edit-request-type` || to.name === `create-request-type`)
                ) {
                    // Форму типа поднимаем синхронно в компоненте, без отложенного scrollBehavior,
                    // чтобы запланированный scroll-to-top не сработал позже уже на таблице.
                    resolve(getCurrentScrollPosition());
                } else if (
                    to.name === `MechanicAssets`
                    && (
                        from.name === `MechanicAssets`
                        || from.name === `MechanicAssetCard`
                        || to.query.highlight
                    )
                ) {
                    resolve(false);
                } else if (
                    to.name === `objects`
                    && (
                        from.name === `objects`
                        || from.name === `object-card`
                        || from.name === `object-create`
                        || to.query.highlight
                    )
                ) {
                    resolve(false);
                } else if (
                    to.name === `reports`
                    && (
                        from.name === `reports`
                        || from.name === `report-card`
                        || to.query.highlight
                    )
                ) {
                    resolve(false);
                } else if (
                    ['employees', 'users'].includes(to.name)
                    && (
                        from.name === to.name
                        || ['employee-details', 'user-card'].includes(from.name)
                        || (to.query && to.query.highlight)
                        || (from.query && from.query.highlight)
                    )
                ) {
                    // Реестр сам выбирает страницу, прокручивает до вернувшегося
                    // сотрудника и запускает подсветку. Отложенный scrollBehavior
                    // не должен через секунду перебивать эту прокрутку возвратом вверх.
                    resolve(getCurrentScrollPosition());
                } else if (
                    to.name === 'employees-workforce-plan'
                    && to.query && to.query.plan_intent === 'focus'
                ) {
                    // The virtual grid reveals the row after loading, including
                    // the outer page on mobile. Do not undo that a second later.
                    resolve(getCurrentScrollPosition());
                } else if (savedPosition) {
                    resolve(savedPosition);
                } else if (from.name === `task-card` && to.name === `tasks`) {
                    const {id} = from.params;
                    const elem = document.getElementById(id);
                    if (elem) {
                        resolve({el: id});
                    } else {
                        resolve();
                    }
                } else {
                    resolve({x: 0, y: 0});
                }
            }, navigator?.connection?.downlink > 4 ? 1000 : 2000);
        })
    }
});

const guard = (to, from, next) => {
    if (to.matched.some(({meta}) => meta.requiresAuth)) {
        const _g = store.getters || store.a.getters;
        if (!_g.isAuthorized) {
            next({
                path: '/login',
                query: {redirect: to.fullPath}
            })
        } else {
            next()
        }
    } else {
        next()
    }
}
router.beforeEach((to, from, next) => {
    const platformRoute = to.matched.some(({meta}) => meta.platform);
    if (platformRoute) {
        const requiresPlatformAuth = to.matched.some(({meta}) => meta.requiresPlatformAuth);
        const platformGuest = to.matched.some(({meta}) => meta.platformGuest);
        if (requiresPlatformAuth && !canRestorePlatformSession()) {
            next({
                path: '/platform/login',
                query: {redirect: to.fullPath}
            });
        } else if (platformGuest && isPlatformAccessTokenValid()) {
            next('/platform');
        } else {
            next();
        }
        return;
    }
    const state = store.state || store.a;
    if (state.appInitialized) {
        guard(to, from, next);
    } else {
        store.dispatch(`initializeApp`)
            .then(() => guard(to, from, next));
    }
});

export default router
